import { applyMiddleware, combineReducers, createStore, Store } from 'redux';
// tslint:disable-next-line:no-implicit-dependencies
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { addressing, ApplicationState, medias, timeline } from './store';

export default function configureStore(initialState: ApplicationState): Store<ApplicationState> {
  const store = createStore(
    combineReducers({
      addressing,
      medias,
      timeline
    }),
    initialState,
    composeWithDevTools(applyMiddleware(thunk))
  );

  return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.ts